import { Route, Routes } from 'react-router-dom';

import { Login } from './Login';
import { Register } from './Register';
import { PasswordRecovery } from './PasswordRecovery';

export const AuthRoutes = () => {
  return (
    <Routes>
      {/* <Route path="register" element={<Register />} /> */}
      <Route path="login" element={<Login />} />
      <Route path="password-recovery" element={<PasswordRecovery />} />
    </Routes>
  );
};